import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  illustrationWrapper: theme => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.sm};
    margin: ${theme.spacing.sm} 0;

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin-top: ${theme.spacing.xs};
      margin-bottom: ${theme.spacing.xs};
    }

    svg {
      max-width: 170px;
      max-height: 170px;
    }
  `,

  caption: theme => css`
    margin-bottom: ${theme.spacing.xs};
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin: 0;
    }
  `,
})

export { useStyles }
